import metadata from "../../libphonenumber-js/metadata.min.json.js";
import { createPhoneInput } from "../modules/PhoneInputWithCountryDefault.js";
import parsePhoneNumber$1 from "../../libphonenumber-js/es6/parsePhoneNumber.js";
import { formatPhoneNumberIntl as formatPhoneNumberIntl$1 } from "../modules/libphonenumber/formatPhoneNumber.js";
function call(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  return args.push(metadata), func.apply(this, args);
}
const ReactPhoneNumberInput = createPhoneInput(metadata);
function parsePhoneNumber() {
  return call(parsePhoneNumber$1, arguments);
}
function formatPhoneNumberIntl() {
  return call(formatPhoneNumberIntl$1, arguments);
}
export {
  ReactPhoneNumberInput as default,
  formatPhoneNumberIntl,
  parsePhoneNumber
};
//# sourceMappingURL=index.js.map
